import { IslandType } from '../blueprint-classes/islands/enums';

export type EmptyIslandDefault = {
	type: IslandType,
	width: number,
	height: number,
	depth: number | { left: number, right: number }
	countertopOverhang: number
};

export const emptyIslandDefaults: Record<string, EmptyIslandDefault> = {
	bar: {
		type: IslandType.Bar,
		width: 84,
		height: 39.25,
		depth: 28,
		countertopOverhang: 10
	},
	grill: {
		type: IslandType.Grill,
		width: 60,
		height: 34.5,
		depth: 28,
		countertopOverhang: 2
	},
	corner: {
		type: IslandType.Corner,
		width: 36,
		height: 37,
		depth: { left: 28, right: 28 },
		countertopOverhang: 2
	},
	smoker: {
		type: IslandType.Smoker,
		width: 30,
		height: 16,
		depth: 28,
		countertopOverhang: 2
	},
	pizza: {
		type: IslandType.Pizza,
		width: 34,
		height: 37,
		depth: 28,
		countertopOverhang: 2
	},
	asado: {
		type: IslandType.Asado,
		width: 30,
		height: 16,
		depth: 28,
		countertopOverhang: 2
	}
};

export enum EmptyIslandDefaults {
	'bar' = 'bar',
	'grill' = 'grill',
	'corner'= 'corner',
	'smoker' = 'smoker',
	'pizza' = 'pizza',
	'asado' = 'asado'
}
